import script from "./CampaignsDynamicTableSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignsDynamicTableSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignsDynamicTableSkeleton.vue?vue&type=style&index=0&id=38f43dfa&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f43dfa"]])

export default __exports__